import { createImage } from 'models';
import type { UploadProgressEvent } from 'ui';
import { uploadFile } from './upload-file';

export const uploadImage = async (
  file: Blob | File | string,
  onProgress?: (progressEvent: UploadProgressEvent) => void,
) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await uploadFile({
    body: formData,
    config: {
      headers: { 'content-type': 'multipart/form-data' },
      onUploadProgress({ loaded, total, ...rest }) {
        onProgress?.({
          loaded,
          percent: Math.floor((loaded / (total ?? loaded)) * 100),
          total,
          ...rest,
        });
      },
      params: {},
    },
  });

  return createImage(response.data);
};
